document.addEventListener("DOMContentLoaded", function () {
  // Store references to our event listeners
  const eventListeners = {
    quantityUp: null,
    quantityDown: null,
    quantityInput: null,
    removeItem: null,
    quickAdd: null,
  };

  let isQuickAdding = false;
  let accordionInit = true;

  // Initialize cart drawer
  initializeCartDrawer();

  // Subscribe to cart updates if available
  if (typeof subscribe === "function") {
    subscribe(PUB_SUB_EVENTS.cartUpdate, handleCartUpdate);
    subscribe(PUB_SUB_EVENTS.cartError, handleCartError);
  }

  function initializeCartDrawer() {
    const cartDrawer = document.getElementById("CartDrawer");
    if (!cartDrawer) return;

    // Remove previous listeners if they exist
    if (eventListeners.quantityUp) {
      document.removeEventListener("click", eventListeners.quantityUp);
    }
    if (eventListeners.quantityDown) {
      document.removeEventListener("click", eventListeners.quantityDown);
    }
    if (eventListeners.quantityInput) {
      document.removeEventListener("input", eventListeners.quantityInput);
    }
    if (eventListeners.removeItem) {
      cartDrawer.removeEventListener("click", eventListeners.removeItem);
    }
    if (eventListeners.quickAdd) {
      document.removeEventListener("submit", eventListeners.quickAdd);
    }

    // Open Cart triggers (these don't need cleanup as they're on static elements)
    document.querySelectorAll("[data-open-cart]").forEach((button) => {
      button.addEventListener("click", openCartDrawer);
    });

    // Close Cart handler
    document.addEventListener("click", (e) => {
      if (e.target.closest(".cart-drawer__close")) {
        closeCartDrawer();
      }
    });

    // Store and setup new event listeners
    eventListeners.removeItem = (e) => {
      if (e.target.closest("[data-remove-item]")) {
        e.preventDefault();
        handleRemoveItem(e.target.closest("[data-remove-item]"));
      }
    };
    cartDrawer.addEventListener("click", eventListeners.removeItem);

    // Initialize quantity controls with proper debouncing
    initQuantityControls();

    // Remove previous listeners
    if (eventListeners.quickAdd) {
      document.removeEventListener("submit", eventListeners.quickAdd);
    }

    // Quick add form handling – drawer (mobile) + sidebar (desktop). Uses pub/sub like mobile.
    eventListeners.quickAdd = async (e) => {
      const form = e.target.closest(
        "form.quick-add-form, form[action*='cart/add']"
      );
      const inCartContext =
        form &&
        (form.closest("#CartDrawer") || form.closest(".cart-upsell-sidebar"));
      if (inCartContext) {
        e.preventDefault();
        await handleQuickAdd(form);
      }
    };
    document.addEventListener("submit", eventListeners.quickAdd);

    // Add touch support for mobile + desktop upsell (.quick-add-btn = card-product, .quick-add-button = product-quick)
    document
      .querySelectorAll(
        "#CartDrawer .quick-add-btn, #CartDrawer .quick-add-button, .cart-upsell-sidebar .quick-add-btn, .cart-upsell-sidebar .quick-add-button"
      )
      .forEach((button) => {
        button.addEventListener(
          "touchend",
          (e) => {
            e.preventDefault();
            const form = button.closest("form");
            if (form) {
              handleQuickAdd(form);
            }
          },
          { passive: false }
        );
      });

    const container = document.querySelector(".cart-drawer .custom-accordion");

    if (!accordionInit && container) {
      new CustomAccordion(container);
    }

    // Init mobile upsell slider on load (filterUpsellProducts only runs on cart refresh)
    fetch("/cart.js")
      .then((r) => r.json())
      .then(filterUpsellProducts)
      .catch(() => {});
  }

  async function handleCartUpdate(data) {
    if (data.action === "add") {
      // Update cart count
      const cartResponse = await fetch("/cart.js");
      const cartData = await cartResponse.json();
      await refreshCartContent(cartData);
      openCartDrawer();
    }
  }

  // Global variable to track pending quantity updates
  let pendingQuantityUpdate = null;

  function initQuantityControls() {
    // Remove previous listeners if they exist
    if (eventListeners.quantityUp) {
      document.removeEventListener("click", eventListeners.quantityUp);
    }
    if (eventListeners.quantityDown) {
      document.removeEventListener("click", eventListeners.quantityDown);
    }
    if (eventListeners.quantityInput) {
      document.removeEventListener("input", eventListeners.quantityInput);
    }

    // Quantity up handler
    eventListeners.quantityUp = async (e) => {
      const btn = e.target.closest("[data-quantity-up]");
      if (btn) {
        e.preventDefault();
        if (pendingQuantityUpdate) return;
        pendingQuantityUpdate = true;
        try {
          const input = btn
            .closest(".cart-item")
            .querySelector("[data-quantity-input]");
          input.value = Number(input.value) + 1;
          debouncedQuantityChange(btn, 0);
        } finally {
          pendingQuantityUpdate = false;
        }
      }
    };
    document.addEventListener("click", eventListeners.quantityUp);

    // Quantity down handler
    eventListeners.quantityDown = async (e) => {
      const btn = e.target.closest("[data-quantity-down]");
      if (btn) {
        e.preventDefault();
        if (pendingQuantityUpdate) return;
        pendingQuantityUpdate = true;
        try {
          const input = btn
            .closest(".cart-item")
            .querySelector("[data-quantity-input]");
          input.value = Number(input.value) - 1;
          debouncedQuantityChange(btn, 0);
        } finally {
          pendingQuantityUpdate = false;
        }
      }
    };
    document.addEventListener("click", eventListeners.quantityDown);

    // Input handler with proper debouncing
    eventListeners.quantityInput = debounce(async (e) => {
      if (e.target.matches("[data-quantity-input]")) {
        const input = e.target;
        const quantityControl = input.closest(".cart-item");
        const maxQuantity = parseInt(quantityControl.dataset.maxQuantity);
        const newQuantity = parseInt(input.value) || 1;

        if (maxQuantity > 0 && newQuantity > maxQuantity) {
          showStockError(quantityControl, `Only ${maxQuantity} available`);
          input.value = maxQuantity;
          return;
        }

        if (pendingQuantityUpdate) return;
        pendingQuantityUpdate = true;
        try {
          await handleQuantityChange(input, 0);
        } finally {
          pendingQuantityUpdate = false;
        }
      }
    }, 750);
    document.addEventListener("input", eventListeners.quantityInput);
  }

  function showStockError(element, message) {
    // Remove existing error if any
    const existingError = element.querySelector(".stock-error");

    existingError.style.marginTop = "0.5rem";
    existingError.textContent = message;
    // Auto-remove after 3 seconds
    setTimeout(() => {
      existingError.textContent = "";
    }, 3000);
  }

  function handleCartError(error) {
    console.error("Cart Error:", error);
    // Show error UI
    const errorElement = document.createElement("div");
    errorElement.className = "cart-error";
    errorElement.textContent = error.error || "Cart operation failed";
    document.getElementById("CartDrawer").prepend(errorElement);
    setTimeout(() => errorElement.remove(), 3000);
  }

  // Shared debounced update (600ms after last click)
  const debouncedQuantityChange = debounce(async (element, change) => {
    await handleQuantityChange(element, change);
  }, 600);

  async function handleQuantityChange(element, change) {
    const drawer = element.closest(".cart-drawer__items");
    const quantityControl = element.closest(".cart-item");
    const input = quantityControl.querySelector("[data-quantity-input]");
    const itemKey = quantityControl.dataset.itemId;
    const maxQuantity = parseInt(quantityControl.dataset.maxQuantity);

    // Calculate new quantity
    let newQuantity =
      change === 0 ? parseInt(input.value) || 1 : Number(input.value) + change;

    // Validate against stock
    if (maxQuantity > 0 && newQuantity > maxQuantity) {
      showStockError(quantityControl, `Only ${maxQuantity} available`);
      input.value = maxQuantity;
      return;
    }

    if (newQuantity < 1) {
      await handleRemoveItem(
        element.closest("[data-remove-item]") ||
          quantityControl.querySelector("[data-remove-item]")
      );
      return;
    }

    // Update UI immediately
    input.value = newQuantity;
    quantityControl.classList.add("updating");
    drawer.classList.add("updating");

    try {
      const changeUrl = window.routes?.cart_change_url || "/cart/change.js";
      const url = changeUrl.endsWith(".js") ? changeUrl : changeUrl + ".js";
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: itemKey, quantity: newQuantity }),
      });

      const text = await response.text();
      const cartData = parseCartResponse(response, text);

      if (typeof publish === "function") {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          action: "update",
          itemKey: itemKey,
          quantity: newQuantity,
          cart: cartData,
        });
      }

      // Only refresh if this is the most recent update
      await refreshCartContent(cartData);
    } catch (error) {
      if (typeof publish === "function") {
        publish(PUB_SUB_EVENTS.cartError, {
          error: error.message,
          context: "update-quantity",
        });
      }
      // Reset to previous value on error
      input.value = Number(input.value) - change;
    } finally {
      quantityControl.classList.remove("updating");
      drawer.classList.remove("updating");
    }
  }

  function parseCartResponse(response, text) {
    try {
      return JSON.parse(text);
    } catch (parseErr) {
      if (response.status === 429) {
        throw new Error(
          "Too many requests. Please wait a moment and try again."
        );
      }
      throw new Error(
        response.ok
          ? "Invalid response from server"
          : `Request failed (${response.status})`
      );
    }
  }

  async function handleRemoveItem(button) {
    const drawer = button.closest(".cart-drawer__items");
    const itemElement = button.closest(".cart-item");
    const itemKey = itemElement.dataset.itemId;

    try {
      button.disabled = true;
      itemElement.classList.add("removing");
      drawer.classList.add("removing");

      const changeUrl = window.routes?.cart_change_url || "/cart/change.js";
      const url = changeUrl.endsWith(".js") ? changeUrl : changeUrl + ".js";
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({ id: itemKey, quantity: 0 }),
      });

      const text = await response.text();
      const cartData = parseCartResponse(response, text);

      publish(PUB_SUB_EVENTS.cartUpdate, {
        action: "remove",
        itemKey: itemKey,
        cart: cartData,
      });

      // Always refresh the entire cart content when removing items
      await refreshCartContent(cartData);
    } catch (error) {
      if (typeof publish === "function") {
        publish(PUB_SUB_EVENTS.cartError, {
          error: error.message,
          context: "remove-item",
        });
      }
      button.disabled = false;
      itemElement.classList.remove("removing");
      drawer.classList.remove("removing");
    }
  }

  function filterUpsellProducts(cartData) {
    const upsellItems = document.querySelectorAll(
      ".cart-upsell .product-card-item"
    );
    const cartUpsell = document.querySelector(".cart-upsell");
    if (!upsellItems.length) return;

    const cartIds = cartData.items.map((item) => item.product_id);

    upsellItems.forEach((item) => {
      const productId = item.querySelector(".quick-card-product")?.dataset
        .productId;
      if (productId && cartIds.includes(Number(productId))) {
        item.remove(); // hide product already in cart
      }
    });

    if (
      document.querySelectorAll(".cart-upsell .product-card-item").length === 0
    ) {
      cartUpsell.style.display = "none";
      cartUpsell.style.opacity = "0";
    } else {
      cartUpsell.style.display = "block";
      cartUpsell.style.opacity = "1";
    }

    // Initialize slider if present
    const slider = cartUpsell.querySelector(".upsell-slider");
    if (slider && window.initUpsellSlider) {
      window.initUpsellSlider(slider);
    }
  }

  async function refreshCartContent(cartData) {
    const cartDrawer = document.getElementById("CartDrawer");
    if (!cartDrawer) return;

    // Show loader on the drawer element itself — survives innerHTML replacement
    cartDrawer.classList.add("cart-loading");

    try {
      const localePrefix = window.Shopify?.routes?.root || "";
      const response = await fetch(`${localePrefix}?section_id=cart`);
      if (!response.ok) throw new Error("Failed to fetch cart content");

      const text = await response.text();
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = text;

      const newCartDrawer = tempDiv.querySelector("#CartDrawer");
      const newSidebar = tempDiv.querySelector(".cart-upsell-sidebar");
      if (!newCartDrawer) throw new Error("Cart drawer not found in response");

      cartDrawer.innerHTML = newCartDrawer.innerHTML;
      cartDrawer.classList.toggle('is-empty', cartData.item_count === 0);

      // Add or remove sidebar based on cart item count
      const existingSidebar = document.querySelector(".cart-upsell-sidebar");
      if (cartData.item_count > 0 && newSidebar) {
        if (existingSidebar) existingSidebar.replaceWith(newSidebar);
        else cartDrawer.after(newSidebar);
        if (typeof initCartUpsellSidebar === "function")
          initCartUpsellSidebar();
      } else if (existingSidebar) {
        existingSidebar.remove();
      }

      // Reinitialize the cart drawer completely
      accordionInit = false;
      initializeCartDrawer();
      initQuickCardProducts();
      filterUpsellProducts(cartData);

      document.querySelectorAll("[data-cart-count]").forEach((el) => {
        cartData.item_count > 0
          ? el.classList.remove("empty")
          : el.classList.add("empty");
        el.textContent = cartData.item_count;
      });

      if (window.free_shipping_enabled) {
        // updateShippingBar(cartData);
      }
    } catch (error) {
      console.error("Error refreshing cart content:", error);
    } finally {
      // Use getElementById — cartDrawer reference may have been replaced by innerHTML swap
      document.getElementById("CartDrawer")?.classList.remove("cart-loading");
    }
  }

  async function handleQuickAdd(form) {
    // Prevent multiple simultaneous submissions
    if (isQuickAdding) return;
    isQuickAdding = true;

    // Get form elements
    const submitButton = form.querySelector('[type="submit"]');
    const spinner = form.querySelector(".loading-spinner-quick");
    const buttonText = submitButton?.querySelector(".button-text");
    const originalText = buttonText?.innerHTML || "";

    try {
      // Set loading state
      if (submitButton) {
        submitButton.disabled = true;
        if (buttonText) {
          buttonText.innerHTML = "";
          buttonText.style.opacity = "0";
        }
        if (spinner) {
          spinner.style.display = "block";
        }
      }

      const formData = new FormData(form);
      const variantId = formData.get("id");

      if (!variantId) {
        throw new Error("No variant ID found");
      }

      const cartAddUrl = (window.routes?.cart_add_url || "/cart/add") + ".js";
      const doAdd = () =>
        fetch(cartAddUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
          }),
        });

      let response = await doAdd();
      if (response.status === 429) {
        await new Promise((r) => setTimeout(r, 1500));
        response = await doAdd();
      }

      const text = await response.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch (parseErr) {
        const msg =
          response.status === 429
            ? "Too many requests. Please wait a moment and try again."
            : response.ok
            ? "Invalid response from server"
            : `Unable to add to cart (${response.status})`;
        throw new Error(msg);
      }

      if (response.status === 429) {
        throw new Error(
          "Too many requests. Please wait a moment and try again."
        );
      }

      if (response.ok) {
        if (typeof publish === "function") {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            action: "add",
            variant: data,
            formData: Object.fromEntries(formData),
            product: {}, // You can pass product data here if available
          });
        }
      } else {
        throw new Error(data.description || "Failed to add to cart");
      }
    } catch (error) {
      console.error("Quick add error:", error);

      // Show error to user
      if (buttonText) {
        buttonText.textContent = "Error - Try Again";
        buttonText.style.opacity = "1";
      }

      if (typeof publish === "function") {
        publish(PUB_SUB_EVENTS.cartError, {
          error: error.message,
          context: "add-to-cart",
        });
      }
    } finally {
      isQuickAdding = false;

      // Reset button state
      if (submitButton) {
        submitButton.disabled = false;
        if (buttonText) {
          buttonText.style.opacity = "1";
          buttonText.innerHTML = originalText;
        }
        if (spinner) {
          spinner.style.display = "none";
        }
      }
    }
  }
});

// function updateShippingBar(cartData) {
//   const freeShippingEnabled =
//     document.querySelector(".free-shipping-bar")?.dataset
//       .freeShippingEnabled === "true";

//   if (!freeShippingEnabled) return;

//   const shippingBar = document.querySelector(".free-shipping-bar");

//   const threshold = parseInt(shippingBar.dataset.shippingThreshold) * 100;
//   const currentTotal = cartData.total_price;
//   const remaining = threshold - currentTotal;

//   const shippingMessage = shippingBar.querySelector(".more_money");
//   const shippingAchieved = shippingBar.querySelector(".shipping-achieved");

//   const progressBar = document.querySelector(".progress-bar .progress");
//   const shippingCostElement = document.querySelector(".shipping-message");

//   const afterMessage = shippingBar.dataset.afterMessage;
//   const beforeMessage = shippingBar.dataset.beforeMessage;

//   const congratulationsMessage = shippingBar.dataset.congratulationsMessage;

//   if (remaining > 0) {
//     // Update progress message
//     if (shippingMessage) {
//       shippingMessage.innerHTML = `
//       <span class="svg__wrapper">${window.shipping}</span>
//       <span>${beforeMessage} ${Shopify.formatMoney(
//         remaining,
//         window.money_without_trailing_zeros_format
//       )} ${afterMessage}</span>`;
//     }

//     // Update progress bar
//     const progressPercent = (currentTotal / threshold) * 100;
//     progressBar.style.width = `${Math.min(progressPercent, 100)}%`;

//     // Hide free shipping message if visible
//     if (shippingCostElement && progressPercent >= 100) {
//       shippingCostElement.style.display = "none";
//     }
//   } else {
//     // Show success message
//     if (shippingAchieved) {
//       shippingAchieved.innerHTML = `
//       <span class="svg__wrapper">${window.success}</span>
//       <span class="shipping-achieved">${congratulationsMessage}</span>
//       `;
//       progressBar.classList.add("done");
//     }

//     // Set progress to 100%
//     if (progressBar) {
//       progressBar.style.width = "100%";
//     }

//     // Show free shipping cost
//     if (shippingCostElement) {
//       shippingCostElement.style.display = "flex";
//     }
//   }
// }
